import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import { CharacterUnlockPopup } from "../ui/CharacterUnlockPopup";
import ActionQueue from "../utils/ActionQueue";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import { PlayerDataUtils } from "../utils/PlayerDataUtils";
import { Environment } from "./FlyState";
import { CharacterUnlockData } from "./MissionsState";
import CharacterAtlas from "./PlayerStates/CharacterAtlas";

export class RecapPopup extends GameObject {

	scene: GameScene;

	constructor(scene: GameScene, distance: number, coins: number) {
		super(scene);	
		this.scene.music.play("music");
		const saveData = PlayerData.Instance.saveData;
		saveData.coins += coins;
		//Apply in game mission progress to save data missions
		const setTypes = ["travelDistance", "collectCoins", "reachEnvironmentIndex"];
		for (const mission of this.scene.currentMissionProgress) {
			const isSetMissionType = setTypes.find((t) => t == mission.type);
			if (isSetMissionType) {
				PlayerData.setMissionProgress(mission.type, mission.amt);
			} else {
				PlayerData.incrementMission(mission.type, mission.amt);
			}
		}

		this.scene.missionTracker.finalMissionUpdate(distance, coins);

		const overlay = this.addImage("missionsBG");
		overlay.setInteractive();

		const popup = scene.add.container();
		this.add(popup);

        const starBurstSpine = scene.add.spine(0, 0, "star-burst", "starburst-idle", true);
        const starBurst = scene.add.spineContainer(0, 0, starBurstSpine);
        popup.add(starBurst);
		const glow = this.addImage("shopBGGlow").setScale(1.25);
		popup.add(glow);

		const resultsGroup = scene.add.container();
		popup.add(resultsGroup);

		const rightBG = this.addImage("recapBacker");
		resultsGroup.add(rightBG);
		resultsGroup.setSize(rightBG.width, rightBG.height);

		const img = this.addImage("recapBedrock");
		if (this.scene.ltGame.currentEnvironment == Environment.METROPOLIS) {
			img.setTexture("recapMetropolis");
		} else if (this.scene.ltGame.currentEnvironment == Environment.HAUNTEDHOUSE) {
			img.setTexture("recapHaunted");
		} else if (this.scene.ltGame.currentEnvironment == Environment.GOTHAM || this.scene.ltGame.currentEnvironment == Environment.ENDING){
			img.setTexture("recapGotham");
		}
		resultsGroup.add(img);

		const character = scene.add.image(0, 0, scene.ltGame.player.img.texture.key, CharacterAtlas.characters[scene.ltGame.player.character.name]["Launch"]);
		character.setScale(0.5);
		if (scene.ltGame.player.img.texture.key.includes("tweety")) character.setScale(0.65);
		resultsGroup.add(character);

		const resultsHeaderGroup = scene.add.container();
		resultsGroup.add(resultsHeaderGroup);

		const header = this.addImage("recapHeader");
		resultsHeaderGroup.add(header);
		resultsHeaderGroup.setSize(header.width, header.height);

		const headerText = scene.add.text(0, 0, Strings.get("Results"), {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "70px",
			strokeThickness: 5,
			stroke: "0x00000"
		});
		resultsHeaderGroup.add(headerText);

		const distanceBacker = scene.add.image(0, 0, "hudBacker");
		resultsGroup.add(distanceBacker);

		const distanceNum = scene.add.text(0, 0, distance.toLocaleString("en-US"), {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "45px",
		});
		resultsGroup.add(distanceNum);

		const m = scene.add.text(0, 0, "m", {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "35px",
			color: GameColors.WHITE
		});
		resultsGroup.add(m);

		const coinBacker = scene.add.image(0, 0, "hudBacker");
		resultsGroup.add(coinBacker);

		const coinNum = scene.add.text(0, 0, coins.toLocaleString("en-US"), {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "45px",
		});
		resultsGroup.add(coinNum);

		const coin = this.addImage("missionCoin").setScale(0.85);
		resultsGroup.add(coin);
		const boot = this.addImage("recapDistIcon").setScale(1.25);
		resultsGroup.add(boot);

		const homeButton = scene.add.button(0, 0, "recapHome", undefined, this.home, this);
		this.add(homeButton);

		const shopButtonGroup = scene.add.container();
		const shopButton = scene.add.button(0, 0, "shopButton", undefined, this.shop, this);
		shopButtonGroup.setSize(shopButton.width, shopButton.height);
		const shopText = scene.add.text(0, 0, Strings.get("Shop").toUpperCase(),{
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "40px",
			align: "center",
			wordWrap: { width: 200, useAdvancedWrap: true }
		});

		const shopBadge = this.addImage("shopBadge");
		resultsGroup.add(shopBadge);
		const shopTutHand = this.addImage("tutHand");
		shopTutHand.setOrigin(10 / shopTutHand.width, 100 / shopTutHand.height);
		shopTutHand.angle = 45;
		scene.tweens.add({
			targets: shopTutHand,
			scale: 1.2,
			ease: Phaser.Math.Easing.Quadratic.Out,
			yoyo: true,
			duration: 500,
			loop: -1,
		});
		scene.time.addEvent({
			delay: 500,
			callback: () => {
				scene.tweens.add({
					targets: shopBadge,
					scale: 1.2,
					ease: Phaser.Math.Easing.Quadratic.Out,
					yoyo: true,
					duration: 500,
					loop: -1,
				});
			}
		});
		shopButtonGroup.add([shopButton, shopText, shopBadge, shopTutHand]);

		const replayButtonGroup = scene.add.container();
		const replayButton = scene.add.button(0, 0, "recapReplay", undefined, this.replay, this);
		replayButtonGroup.setSize(replayButton.width, replayButton.height);
		const replayText = scene.add.text(0, 0, Strings.get("Replay").toUpperCase(),{
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "40px",
			align: "center",
			wordWrap: { width: 200, useAdvancedWrap: true }
		});
		replayButtonGroup.add([replayButton, replayText]);

		resultsGroup.add([replayButtonGroup, shopButtonGroup]);

		let canAffordUpgrade = false;
		const items = ["rubberBand", "grease", "anvil", "detonator", "steelBall"];
		for (let i = 0; i < 5; i++) {
			const saveData = PlayerData.Instance.saveData;
			const itemName = items[i];
			const data = GameConfig.get<any>("items")[itemName];
			const level = saveData.items[itemName];
			if (level >= 5) continue;
			const price = data.price[level];
			if (saveData.coins >= price) canAffordUpgrade = true;
		}
		if (!canAffordUpgrade) shopBadge.visible = false;
		shopTutHand.visible = canAffordUpgrade && !saveData.boughtItem;

		const missionsGroup = scene.add.container();
		popup.add(missionsGroup);

		const missionsBacker = scene.add.image(0, 0, "missionsBacker");
		missionsGroup.add(missionsBacker);
		missionsGroup.setSize(missionsBacker.displayWidth, missionsBacker.displayHeight);
		const headerStyle = {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			align: "center",
			stroke: "#000000",
			strokeThickness: 5,
			fontSize: "80px",
		}
		const missionsHeader = scene.add.text(0, 0, Strings.get("GreatLaunch"), headerStyle);
		missionsHeader.setOrigin(0, 0.5);
		missionsGroup.add(missionsHeader);

		this.scene.addResize(() => {
			overlay.setSize(scene.viewport.width, scene.viewport.height);
			overlay.setDisplaySize(scene.viewport.width, scene.viewport.height);
			scene.alignIn.TopLeft(homeButton, overlay, -50, -50);
			const popupScale = Math.min(scene.viewport.width / 1920, 1);
			popup.scale = popupScale;
		});
		scene.alignIn.Center(glow, overlay);
		scene.alignIn.Center(resultsGroup, overlay, 280);
		scene.alignIn.TopCenter(resultsHeaderGroup, rightBG, 180, 50);
		scene.alignIn.Center(headerText, header, 0, -10);
		scene.alignIn.BottomCenter(distanceBacker, resultsHeaderGroup, 120, 55);
		scene.alignIn.BottomCenter(coinBacker, resultsHeaderGroup, -120, 55);
		scene.alignIn.BottomCenter(img, resultsHeaderGroup, -5, 550);
		scene.alignIn.Center(character, img, -50, 0);

		scene.alignIn.Center(starBurst, rightBG, -50, 0);
		scene.alignIn.Center(missionsGroup, overlay, -450, -25);

		scene.alignIn.Center(distanceNum, distanceBacker, 10, -5);
		scene.alignIn.Center(coinNum, coinBacker, 10, -5);

		scene.alignIn.RightCenter(m, distanceNum, 35, 10);

		scene.alignIn.LeftCenter(coin, coinBacker, -5, 0);
		scene.alignTo.LeftCenter(boot, distanceBacker, -50, 0);

		scene.alignIn.TopLeft(homeButton, overlay, 34, -34);
		scene.alignIn.BottomCenter(shopButtonGroup, rightBG, 60, 50);
		scene.alignIn.TopRight(shopBadge, shopButton, 0, 5);
		shopTutHand.setPosition(shopButton.x - 10, shopButton.y);
		scene.alignIn.BottomCenter(replayButtonGroup, rightBG, 270, 50);
		scene.alignTo.BottomCenter(shopText, shopButton, 0, -3);
		scene.alignTo.BottomCenter(replayText, replayButton, 0, -3);
		missionsGroup.scale = 0.85;
		// missionsGroup.x -= 100;

		const mashupText = scene.add.text(0, 0, Strings.get("MashupParty").toUpperCase(), {
			fontFamily: Fonts.MaliBoldItalic,
			color: "#352E29",
			fontSize: "38px",
		});
		LayoutUtils.scaleToMaxWidth(mashupText, 450);
		mashupText.setOrigin(0.5);
		missionsGroup.add(mashupText);
		mashupText.rotation = 6.17;
		scene.alignIn.Center(mashupText, missionsBacker, -20, -380);
		scene.alignIn.TopCenter(missionsHeader, missionsBacker, 0, -245);

		// let missionPreProgress: number[] = [];
		// for (let i = 0; i < 3; i++) {
		// 	const mission = PlayerData.Instance.saveData.missions[i];
		// 	const clampedProgress = Phaser.Math.Clamp(mission.progress, 0, mission.goal);
		// 	missionPreProgress.push(clampedProgress);
		// }
		const missions = [...PlayerData.Instance.saveData.missions];
		const charUnlockPreProgress = saveData.missionsCompleteForCharacterUnlock / saveData.missionsToNextCharacterUnlock;

		// progress missions
		PlayerData.progressMissions(PlayerData.Instance.saveData);

		const missionMeterTweens: ((complete: () => void) => void)[] = [];
		for (let i = 0; i < 3; i++) {
			const mission = missions[i];

			const box = this.addImage("whiteSquare");
			popup.add(box);
			box.setSize(1000, 120);
			box.setDisplaySize(1000, 120);
			box.tint = 0x888888;
			box.alpha = 0.0001;
			scene.alignIn.TopCenter(box, missionsBacker, 0, -400 - 120 * i);
			let goalStr = mission.goal.toLocaleString("en-US");
			const clampedProgress = Phaser.Math.Clamp(mission.progress, 0, mission.goal);
			let progressStr = clampedProgress.toLocaleString("en-US");
			let str = Strings.get(mission.type).replace("%N", goalStr + "");
			if (mission.type == "reachEnvironmentIndex") {
				str = Strings.get("reachEnvironment" + mission.goal);
				const envGoal = 1;
				const envProgress = (mission.goal <= mission.progress) ? 1 : 0;
				goalStr = envGoal.toLocaleString("en-US");
				progressStr = envProgress.toLocaleString("en-US");
			}
			const missionText = scene.add.text(0, 0, str.toUpperCase(), {
				fontFamily: Fonts.MaliMediumItalic,
				color: "#FFEDDF",
				fontSize: "32px",
				align: "left"
			});
			missionsGroup.add(missionText);
			LayoutUtils.scaleToMaxWidth(missionText, 640);
			scene.alignIn.TopLeft(missionText, box, -95, -5);

			const meter = this.addImage("meterEmpty");
			scene.alignIn.BottomCenter(meter, box, 0, -30);
			missionsGroup.add(meter);

			// const preProgress = missionPreProgress[i];
			let progress = mission.progress / mission.goal;
			if (mission.type == "reachEnvironmentIndex" && mission.goal > mission.progress) progress = 0;
			const maxWidth = meter.width - 12;
			// const meterPreWidth = preProgress < 1 ? preProgress * maxWidth : maxWidth;
			const meterPostWidth = progress < 1 ? progress * maxWidth : maxWidth;

			const greenFill = scene.add.nineSlicedSprite(0, 0, "meterGreenFill", meterPostWidth, 28, 5, 5, 5, 5);
			greenFill.displayWidth = 0;
			// greenFill.displayWidth = meterPreWidth;
			missionsGroup.add(greenFill);
			greenFill.setOrigin(0);
			scene.alignIn.LeftCenter(greenFill, meter, -6, 0);

			const progressText = scene.add.text(0, 0, `${progressStr}/${goalStr}`, {
				fontFamily: Fonts.LuckiestGuy,
				color: "#FB9819",
				fontSize: "32px",
			});
			missionsGroup.add(progressText);
			scene.alignTo.LeftCenter(progressText, meter, 30, 0);

			const rewardBacker = this.addImage("coinPriceBacker");
			scene.alignIn.RightCenter(rewardBacker, box, -50, 5);
			missionsGroup.add(rewardBacker);

			const coin = this.addImage("missionCoin").setScale(0.8);
			scene.alignIn.LeftCenter(coin, rewardBacker, -10, 0);
			missionsGroup.add(coin);

			const rewardText = scene.add.text(0, 0, mission.reward.toLocaleString("en-US") + "", {
				fontFamily: Fonts.LuckiestGuy,
				color: "#FBF7E7",
				fontSize: "55px",
			});
			missionsGroup.add(rewardText);
			rewardText.scale = Math.min(98 / rewardText.width, 1);
			rewardText.setSize(rewardText.displayWidth, rewardText.displayHeight);
			scene.alignTo.RightCenter(rewardText, coin, 5, -3);

			const check = this.addImage("missionCheck");
			missionsGroup.add(check);
			scene.alignIn.Center(check, rewardBacker);
			check.scale = 0;

			missionMeterTweens.push(complete => {
				if (meterPostWidth != 0) {
					scene.add.tween({
						targets: greenFill,
						displayWidth: meterPostWidth,
						duration: 600,
						onComplete: () => {
							if (progress >= 1) {
								this.scene.soundManager.play("missionComplete");
								this.scene.tweens.add({
									targets: check,
									displayWidth: rewardBacker.displayWidth,
									displayHeight: rewardBacker.displayHeight,
									duration: 400,
									ease: Phaser.Math.Easing.Back.Out,
								});
							}
							complete();
						},
					});
				}
				else complete();
			});
		}

		const unlockGroup = scene.add.container(0, 0);
		popup.add(unlockGroup);

		if (saveData.missionsToNextCharacterUnlock != -1) {
			const charUnlockBG = this.addImage("nextCharBacker");
			unlockGroup.add(charUnlockBG);
			unlockGroup.setSize(charUnlockBG.width, charUnlockBG.height);
			scene.alignIn.BottomCenter(unlockGroup, missionsBacker, 0, -100);
			const charUnlockIcon = this.addImage("nextCharImg");
			scene.alignIn.LeftCenter(charUnlockIcon, charUnlockBG, -20, -5);
			unlockGroup.add(charUnlockIcon);

			const missionsLeft = saveData.missionsToNextCharacterUnlock - saveData.missionsCompleteForCharacterUnlock;
			let unlockStr = Strings.get("NextCharacterUnlockedIn").replace("%N", missionsLeft + "").toUpperCase();
			if (missionsLeft <= 0) unlockStr = Strings.get("NewCharacterUnlocked");
			const charUnlockText = scene.add.text(0, 0, unlockStr, {
				fontFamily: Fonts.MaliMediumItalic,
				color: "#352E9",
				fontSize: "32px",
				wordWrap: {width: 550, useAdvancedWrap: true},
				align: "center"
			});
			unlockGroup.add(charUnlockText);
			scene.alignIn.Center(charUnlockText, charUnlockBG, 100, -30);
			charUnlockText.rotation = 0.025;

			const meter = this.addImage("meterEmpty");
			meter.rotation = 0.025;
			unlockGroup.add(meter);
			scene.alignIn.BottomCenter(meter, charUnlockBG, 100, -45);

			const fill = this.addImage("meterRedFill");
			fill.setOrigin(0, 0.5);
			fill.rotation = 0.025;
			unlockGroup.add(fill);
			scene.alignIn.LeftCenter(fill, meter, -6, -5);

			const charUnlockPostProgress = saveData.missionsCompleteForCharacterUnlock / saveData.missionsToNextCharacterUnlock;
			const charUnlockPreWidth = Phaser.Math.Clamp(charUnlockPreProgress, 0, 1) * (meter.width - 12);
			const charUnlockPostWidth = Phaser.Math.Clamp(charUnlockPostProgress, 0, 1) * (meter.width - 12);
			fill.displayWidth = charUnlockPreWidth;

			missionMeterTweens.push(complete => {
				if (charUnlockPostProgress != charUnlockPreWidth) {
					scene.add.tween({
						targets: fill,
						displayWidth: charUnlockPostWidth,
						duration: 600,
						onComplete: complete,
					});
				}
				else complete();
			});
		}
		unlockGroup.setScale(0.85);
		
		if(!shopTutHand.visible && PlayerDataUtils.CanUnlockFirstCharacter()) shopTutHand.visible = true;

		const characterUnlocked = (saveData.missionsToNextCharacterUnlock > -1) && (saveData.missionsCompleteForCharacterUnlock >= saveData.missionsToNextCharacterUnlock);
		if (characterUnlocked) {
			saveData.charactersUnlocked++;

			const characterUnlocks = GameConfig.get<CharacterUnlockData[]>("characterUnlocks");
			
			let nextCharacterIndex = saveData.charactersUnlocked + 1;

			if (nextCharacterIndex < characterUnlocks.length) {
				saveData.missionsToNextCharacterUnlock = characterUnlocks[nextCharacterIndex].missionsToComplete;
				saveData.missionsCompleteForCharacterUnlock = 0;
			}
			else {
				saveData.missionsToNextCharacterUnlock = -1;
			}
		}
		PlayerData.Instance.save();

		this.scene.resize();

		const queue = new ActionQueue();

		popup.y += 1000;
		popup.angle -= 15;
		const missionsX = missionsGroup.x;
		missionsGroup.x = 0;
		overlay.alpha = 0;
		queue.add(complete => {
			this.scene.tweens.add({
				targets: overlay,
				alpha: 1,
				duration: 200,
				ease: Phaser.Math.Easing.Linear,
			});

			this.scene.tweens.add({
				targets: popup,
				y: popup.y - 1000,
				duration: 400,
				ease: Phaser.Math.Easing.Back.Out,
			});

			this.scene.tweens.add({
				targets: popup,
				angle: 0,
				duration: 400,
				ease: Phaser.Math.Easing.Back.Out,
			});

			this.scene.time.delayedCall(300, complete);
		});

		const missionsContent = missionsGroup.list.filter(o => o != missionsBacker) as Phaser.GameObjects.Image[];
		missionsContent.forEach(o => o.alpha = 0);
		missionsHeader.scale = 0;
		const unlockY = unlockGroup.y;
		unlockGroup.y += 1500;
		queue.add(complete => {
			this.scene.tweens.add({
				targets: missionsContent,
				alpha: 1,
				duration: 200,
				ease: Phaser.Math.Easing.Linear,
				onComplete: complete,
			});

			this.scene.tweens.add({
				targets: missionsHeader,
				scale: 1,
				duration: 400,
				ease: Phaser.Math.Easing.Back.Out,
			});

			this.scene.tweens.add({
				targets: unlockGroup,
				y: unlockGroup.y - 1500,
				duration: 400,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
		});

		for (const tween of missionMeterTweens) {
			queue.add(tween);
		}

		if (characterUnlocked) {
			queue.add(complete => {
				this.scene.tweens.add({
					targets: missionsGroup,
					y: missionsGroup.y + 2000,
					duration: 400,
					ease: Phaser.Math.Easing.Back.In,
				});

				this.scene.tweens.add({
					targets: unlockGroup,
					y: 0,
					duration: 400,
					ease: Phaser.Math.Easing.Back.In,
					onComplete: complete,
				});
			});

			queue.add(complete => {
				this.scene.tweens.add({
					targets: unlockGroup,
					scale: 0,
					duration: 300,
					ease: Phaser.Math.Easing.Back.In,
				});

				const unlockPopup = new CharacterUnlockPopup(scene, complete, this);
				popup.add(unlockPopup);
			});

			queue.add(complete => {
				unlockGroup.scale = 1;
				unlockGroup.y = unlockY;
				missionsGroup.y = missionsGroup.y - 2000;
				complete();
			});
		}

		resultsGroup.visible = false;
		const resultsX = resultsGroup.x;
		resultsGroup.x = 0;
		resultsGroup.scale = 0.65;
		resultsHeaderGroup.y -= 500;
		queue.add(complete => {
			this.scene.tweens.add({
				targets: [missionsGroup, unlockGroup],
				x: missionsX,
				duration: 250,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});

			resultsGroup.visible = true;
			this.scene.tweens.add({
				targets: resultsGroup,
				x: resultsX,
				scale: 1,
				duration: 250,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});

			this.scene.tweens.add({
				targets: resultsHeaderGroup,
				y: resultsHeaderGroup.y + 500,
				duration: 250,
				delay: 150,
				ease: Phaser.Math.Easing.Quadratic.Out,
				onComplete: complete,
			});
		});

		shopButtonGroup.scale = 0;
		replayButtonGroup.scale = 0;
		homeButton.scale = 0;
		queue.add(complete => {
			this.scene.tweens.add({
				targets: shopButtonGroup,
				scale: 1,
				duration: 250,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});

			this.scene.tweens.add({
				targets: replayButtonGroup,
				scale: 1,
				duration: 250,
				delay: 100,
				ease: Phaser.Math.Easing.Quadratic.Out,
				onComplete: complete,
			});

			this.scene.tweens.add({
				targets: homeButton,
				scale: 1,
				duration: 250,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
		});

		queue.start();
	}

	home(): void {
		this.scene.gotoSplash();
	}

	shop(): void {
		this.scene.gotoShop();
	}

	replay(): void {
		this.scene.restart();
	}
}